// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pcard {\n  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  border-color: red;\n  border-width: medium;\n  padding: 3%;\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
